import {ChangeDetectorRef, Pipe, PipeTransform} from "@angular/core";
import {UnitsQuery} from "../system/units/unit.store";
import {DecimalPipe} from '@angular/common';
import {UnitQuery} from "../system/units/unit.query";


@Pipe({
  name: 'unitNumber',
  pure: false
})
export class UnitNumberPipe implements PipeTransform {
  private val: string = '';
  private originalValue?: number;
  private unit: UnitQuery;

  constructor(private _ref: ChangeDetectorRef, private unitsQuery: UnitsQuery, private decimalPipe: DecimalPipe) {
  }

  transform(value?: number, unitId?: string, hideCode?: boolean, roundingFactor: number = null): any {
    if (unitId && !this.unit) {
      this.unitsQuery.selectEntity(unitId).subscribe(value1 => {
        if (value1) {
          this.unit = value1;
          this._ref.markForCheck();
        }
      })
    }

    let unitCode = '';
    let unitRoundingFactor = 2;
    if (this.unit) {
      unitCode = ' ' + this.unit.Code;
      if (this.unit.RoundingFactor) {
        unitRoundingFactor = this.unit.RoundingFactor;
      }
    }
    if (roundingFactor){
      unitRoundingFactor = roundingFactor;
    }

    if (hideCode) {
      unitCode = '';
    }
    let result = '';
    if (value != null) {
      try {
        result = this.decimalPipe.transform(value, '1.' + unitRoundingFactor + '-' + unitRoundingFactor).replace(/(,0*|(?<=(,,*))0*)$/, '') + unitCode;
      }
      catch(e) {
        result = e;
      }
    } else {
      result = '0' + unitCode;
    }
    return result;
  }
}

